module.exports = __webpack_public_path__ + "static/media/integral_card_pic.d08c4bd9.png";